// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1wQ7n","tab":"ProcedureTabs_tab__1uLHp"};